// ui/molecules/ToggleSwitch/ToggleSwitch.jsx
import { Switch } from "radix-ui";
import SwitchThumb from "../../../atoms/controls/switch/SwitchThumb";
import { cn } from "../../../../helpers/utils";

export default function ToggleSwitch({
  checked,
  onChange,
  disabled,
  className,
}) {
  return (
    <Switch.Root
      checked={checked}
      onCheckedChange={onChange}
      disabled={disabled}
      aria-label="toggle"
      className={cn(
        "group relative inline-flex w-14 h-8 items-center rounded-full border border-gray-200 bg-gray-100",
        "transition-colors duration-200 ease-in-out disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/5",
        className
      )}
    >
      <SwitchThumb checked={checked} />
    </Switch.Root>
  );
}
